import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fc14783c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "basePageWraper" }
const _hoisted_2 = { class: "fixTop" }
const _hoisted_3 = { class: "top_menu" }
const _hoisted_4 = { class: "tabs is-centered" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "공개문서", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "내부문서", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "작성중 문서", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "cont_area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_public_doc_list = _resolveComponent("public_doc_list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gotoLinkMenu(1))),
              class: _normalizeClass({'is-active' : _ctx.isGetMenuActive(1)})
            }, _hoisted_6, 2),
            _createElementVNode("li", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.gotoLinkMenu(2))),
              class: _normalizeClass({ 'is-active': _ctx.isGetMenuActive(2)})
            }, _hoisted_8, 2),
            _createElementVNode("li", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.gotoLinkMenu(3))),
              class: _normalizeClass({ 'is-active': _ctx.isGetMenuActive(3)})
            }, _hoisted_10, 2)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      (_ctx.isGetMenuActive(1))
        ? (_openBlock(), _createBlock(_component_public_doc_list, {
            key: 0,
            openType: 2
          }))
        : _createCommentVNode("", true),
      (_ctx.isGetMenuActive(2))
        ? (_openBlock(), _createBlock(_component_public_doc_list, {
            key: 1,
            openType: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isGetMenuActive(3))
        ? (_openBlock(), _createBlock(_component_public_doc_list, {
            key: 2,
            openType: 0
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}